const CFM_RASPBERRY = '#ff3b30';
const CFM_ORANGE = '#ff8c00';
export const CFM_BANANA = '#ffc341';
const CFM_KIWI = '#86ad20';
export const CFM_BLUEBERRY = '#0576b9';
export const CFM_BLACKBERRY = '#2e2d4c';
const CFM_MILK = '#fff';
export const CFM_VOLCANO = '#3c4248';
export const CFM_STONE = '#788590';
export const CFM_METAL = '#ced4d9';
const CFM_FOG = '#dce3eb';
const CFM_CLOUD = '#f6f7f9';
const CFM_MILKSHAKE1 = '#ffc341';
const CFM_MILKSHAKE2 = '#f54752';
const CFM_DOLPHIN = '#e1edff';
const CFM_ALUMINIUM = '#e9eef3';
const CFM_SNOW = '#f0f3f5';
